import { useAppSelector } from '@hooks/app/redux';
import { Button, Form, Select, TextField } from '@ui';
import React from 'react';
import { CirclePicker } from 'react-color';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { actions } from '../../store/ducks/tags-page';
import { FormValueNames } from '../../types/tags-page';
import { CreateTagFormSC } from './create-tag-form.styled';
import { useCreateTagFormData } from './create-tag-form.utils';

interface CreateTagFormProps {}

const PRESET_COLORS = [
  '#5F88E8',
  '#258090',
  '#53981E',
  '#B3850F',
  '#D16C33',
  '#B54C28',
  '#AA344A',
  '#AA68B4',
  '#835CB3',
  '#4B0F1B',
  '#696FA4',
  '#4A76B1',
];

const CreateTagForm: React.FC<CreateTagFormProps> = ({}) => {
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const activeTag = useAppSelector((state) => state.tagsPage.activeTag);
  const submitting = useAppSelector((state) => state.tagsPage.submitting);

  const { validationSchema, initialValues, abbreviationLength, settingsOptions } =
    useCreateTagFormData(activeTag);

  const [, formOptions] = Form.useForm({
    validationSchema,
    initialValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(actions.submitForm(values));
      dispatch(actions.setActiveTag(null));
    },
  });

  return (
    <CreateTagFormSC>
      <Form {...formOptions}>
        <Form.Field
          name={FormValueNames.tagName}
          required
          label={formatMessage({ id: FormValueNames.tagName })}
        >
          <TextField />
        </Form.Field>
        <Form.Field
          name={FormValueNames.abbreviation}
          required
          label={formatMessage({ id: FormValueNames.abbreviation })}
          maxLength={abbreviationLength}
        >
          <TextField />
        </Form.Field>
        <Form.Field
          name={FormValueNames.color}
          required
          label={formatMessage({ id: FormValueNames.color })}
          valuePropName="color"
          getValueFromEvent={(e) => e.hex}
        >
          <CirclePicker
            colors={PRESET_COLORS}
            circleSpacing={10}
            circleSize={45}
            styles={{ default: { card: { marginBottom: 0 } } }}
          />
        </Form.Field>
        <Form.Field
          name={FormValueNames.settings}
          label={formatMessage({ id: FormValueNames.settings })}
          getValueFromEvent={(e) => e}
          required
        >
          <Select options={settingsOptions} />
        </Form.Field>
        <Form.Custom>
          {() => (
            <>
              <Button
                style={{ marginTop: 16 }}
                className={'submit-button'}
                size={'large'}
                type="submit"
                variant={'primary'}
                disabled={submitting}
              >
                <span>
                  {formatMessage({
                    id: activeTag && activeTag.id ? 'tags_submit_update' : 'form_submit',
                  })}
                </span>
              </Button>
            </>
          )}
        </Form.Custom>
      </Form>
    </CreateTagFormSC>
  );
};

export default CreateTagForm;
